/**
 * Comet decoration
 * 
 * @since 1.0.0
 * @package crunchy
 */

(function($) {
	$(document).ready(function() {

		// get triggers
		var triggers = $( '[data-trigger-comets]' );

		// bind
		triggers.on( 'inview', doFlyIn );


		/**
		 * Fly comet in
		 */
		function doFlyIn( e, isInView ) {

			// only do when GETTING TO the trigger
			if ( isInView ) {

				// get target comets
				var targets = $(this).data( 'trigger-comets' );
				    targets = $( '#' + targets + ' .comet' );

				// add fly-in class
				targets.addClass( 'fly-in' );
			}
		}

	}); // document.ready
})(jQuery);
